export default __webpack_public_path__ + "static/media/work_with_households_icon.27e1487a.svg";